import axios from "axios";

export const FaqAPI = {
  getAll: function (limit = 9999) {
    return axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/faq/get`,
      params: {
        limit: limit,
      },
    });
  },
};
